import { type HardwareMicButtonPressedPayload } from '@/tauri/dictation/api';
import {
  deviceButtonMappingsAtom,
  dictateMapFunctionalityDialogRequestAtom,
} from '@heidi/dictate/data';
import { getDefaultStore } from 'jotai';

import { handleNextField } from './next-field';

const NEXT_FIELD = 'next_field';

const resolvedAction = (
  payload: HardwareMicButtonPressedPayload
): HardwareMicButtonPressedPayload['action'] =>
  getDefaultStore().get(deviceButtonMappingsAtom)[payload.deviceKey]?.[
    payload.buttonId
  ] ?? payload.action;

export const handleNextFieldPress = (payload: HardwareMicButtonPressedPayload): void => {
  if (getDefaultStore().get(dictateMapFunctionalityDialogRequestAtom) !== null) {
    return;
  }
  if (resolvedAction(payload)?.type !== NEXT_FIELD) {
    return;
  }
  handleNextField();
};
